import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import icons from '../../assets/comet/comet.svg';
import ProgressBar from '../ProgressBar';
import './styles.styl';

class UtilityBar extends Component {
  toggleSidebar = () => {
    this.props.setSidebarToggled(!this.props.sidebarToggled);
  };

  render() {
    const {
      currentPage,
      prevPage,
      sectionTitles,
      progressBarImage
    } = this.props;

    const currentSectionTitle = sectionTitles[currentPage]
      ? sectionTitles[currentPage]
      : null;

    return (
      <div className="utility-bar">
        <div className="utility-bar__section">
          {prevPage && (
            <div className="utility-bar__section__back-button">
              <Link to={prevPage}>
                <span className="comet-screenreader-only">Previous Page</span>
                <svg
                  className="comet-icon--l"
                  aria-hidden="true"
                  focusable="false"
                >
                  <use xlinkHref={`${icons}#caret-left`} />
                </svg>
              </Link>
            </div>
          )}

          {currentSectionTitle && (
            <div className="utility-bar__section__section-title">
              {currentSectionTitle}
            </div>
          )}
        </div>

        <ProgressBar progressBarImage={progressBarImage} />

        <button
          aria-expanded={this.props.sidebarToggled}
          aria-controls="layout__sidebar__content"
          className="utility-bar__sidebar-toggle"
          onClick={this.toggleSidebar}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
          <span className="comet-screenreader-only">Main Menu</span>
        </button>
      </div>
    );
  }
}

export default UtilityBar;



// WEBPACK FOOTER //
// ../core/src/components/UtilityBar/UtilityBar.js